import styled from 'styled-components';
import PropTypes from 'prop-types';
import { spacingMixin } from '@zillow/constellation';
import customPropTypes from '../../utils/custom-prop-types.js';

var IframeWithAspectRatio = /*#__PURE__*/styled.iframe.withConfig({
  componentId: "sc-m9v0q7-0"
})(["aspect-ratio:", ";max-width:100%;width:", "px;height:100%;", ""], function (props) {
  return props.width + " / " + props.height;
}, function (props) {
  return props.width;
}, spacingMixin);
IframeWithAspectRatio.propTypes = {
  width: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired,
  margin: customPropTypes.inlineMediaQuery(PropTypes.shape({
    marginTop: PropTypes.string,
    marginRight: PropTypes.string,
    marginLeft: PropTypes.string,
    marginBottom: PropTypes.string
  }))
};
IframeWithAspectRatio.defaultProps = {};
/** @component */
var IframeWithAspectRatio$1 = IframeWithAspectRatio;

export { IframeWithAspectRatio$1 as default };
